import React, { useState } from "react";
import { FootBar } from "../components/Footer";
import { UserApi } from "../app/api/user.api";



export function ForgottenPwd()
{
    const user = UserApi();

    const [inputs, setInputs] = useState();
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    
    const handleInputs = ( event ) => {
        const { name , value } =  event.target;
        setInputs( { ...inputs, [name] : value } );
    }

    const handleForm = async (e) => {
        e.preventDefault();
        setStatus(0);
        setIsLoading(true);
        try {
            const {data} = await user.genPasswordToken(inputs);
            setIsLoading(false);
            ( data.success ) ? setStatus(1) : setStatus(-1);
        } catch (err) { 
            setStatus(-1);
            setIsLoading(false);
        }
    }
    
    
    return(

        <div className="container-fluid">         
            <div className="row bg-light">
                {/* ------------------------------------ */}
                <div className="col-lg-12 d-flex align-items-center justify-content-center vh-100"> 
                    <div className="row d-flex justify-content-center w-100">
                        <div className="col-lg-5 col-md-7">
                            <div className="d-flex justify-content-center mb-3" >
                                <span className="d-flex align-items-center justify-content-center border bg-white px-4 py-2 rounded-3">
                                    <img src={'../favicon.png'} className="" alt="Logement extérieur" style={{ width: "80px" }} />
                                </span>
                            </div>
                            <div className="mb-4 bg-white px-4 py-4 rounded-3 d-flex justify-content-center shadow-sm"> 
                                <span className="lead text-secondary"> Mot de passe oublié, renseignez votre email et cliquer sur bouton send. Un mail vous sera envoyé. </span> 
                            </div>                   
                            {
                              isLoading && (
                                <div className="d-flex justify-content-center align-items-center mb-4"> 
                                   <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                                </div>
                              )
                            }
                            {
                              (status === 1) && (
                                <div className="col-md-12 mb-4">
                                  <div className="alert alert-success text-secondary">
                                    Vueillez consulter votre boite mail un lien de modification vous sera envoyé.
                                  </div>
                                </div>
                              )
                            }
                            {
                              (status === -1) && (
                                <div className="col-md-12 mb-4">
                                  <div className="alert alert-danger text-secondary">
                                    Une erreur est survenue durant le traitement. Vueillez réessayer.
                                  </div>
                                </div>
                              )
                            }
                            <form className="d-flex w-100 p-4 bg-white shadow-sm rounded-3" onSubmit={ handleForm }>
                                <div className="d-flex w-100">
                                    <input type="email" name="email" className="p-3 w-100 border input text-secondary rounded-start" placeholder="Email..." required onChange={ handleInputs } />
                                    <button className="px-3 border btn text-secondary d-flex align-items-center justify-content-center rounded-end"> 
                                        <i className="bi bi-send"></i> 
                                    </button>
                                </div>
                            </form>       
                        </div>
                    </div>
                </div>
                {/* ************************************************* */}
                <div className="col-lg-12 bg-dark">  <FootBar />  </div>
                {/* ************************************************* */}
            </div>
        </div>

    )
}

